export default "__VITE_ASSET__1esoElFj__"